import type { ReactNode } from 'react';
import { Text } from '@musa.tech/design-system';

interface DetailFieldProps {
  label: string;
  value: ReactNode;
}

/** Rótulo em caixa alta e valor na mesma linha — padrão dos campos no detalhamento de fatura/medição. */
export function DetailField({ label, value }: DetailFieldProps) {
  return (
    <div className="flex items-baseline gap-2">
      <Text variant="caption" size="xsmall" className="uppercase tracking-wide text-neutral-500">
        {label}
      </Text>
      <Text variant="body" size="small" className="text-neutral-900">
        {value}
      </Text>
    </div>
  );
}
